import {createFileRoute, redirect} from '@tanstack/react-router'

/** Legacy short-prefix URL → /live/clash-of-teams/{slug-or-uid}. */
export const Route = createFileRoute('/live/cot/$uid')({
    beforeLoad: ({params}) => {
        throw redirect({to: `/live/clash-of-teams/${params.uid}`} as any)
    },
})
